import { useEffect, useMemo, useState } from "react";
import { BANNER_CONFIG } from "../config/bannerConfig";
import "./global-promo-banner.css";

function isBannerActive(banner, now = new Date()) {
  if (!banner?.enabled) {
    return false;
  }

  const start = banner.startsAt ? new Date(banner.startsAt) : null;
  const end = banner.endsAt ? new Date(banner.endsAt) : null;

  if (start && now < start) {
    return false;
  }

  if (end && now >= end) {
    return false;
  }

  return true;
}

export default function GlobalPromoBanner() {
  // Banner schedules depend on the visitor's clock, so they are evaluated after mount.
  // Server-prerendered HTML (built at a different time) and the first client render
  // then both render nothing, which keeps hydration consistent.
  const [now, setNow] = useState(null);
  useEffect(() => {
    setNow(new Date());
  }, []);
  const activeBanners = useMemo(
    () => (now ? BANNER_CONFIG.globalPromoBanners.filter((banner) => isBannerActive(banner, now)) : []),
    [now]
  );
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (activeBanners.length <= 1) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setActiveIndex((index) => (index + 1) % activeBanners.length);
    }, 6000);

    return () => window.clearInterval(timer);
  }, [activeBanners.length]);

  if (activeBanners.length === 0) {
    return null;
  }

  const banner = activeBanners[activeIndex];

  return (
    <section className="global-promo" aria-label="Promo">
      <a
        className="global-promo-link"
        href={banner.href}
        target="_blank"
        rel="noopener noreferrer sponsored"
      >
        <picture>
          {banner.mobileImageSrc ? (
            <source
              media="(max-width: 640px)"
              srcSet={banner.mobileImageSrc}
              width={banner.mobileWidth}
              height={banner.mobileHeight}
            />
          ) : null}
          <img
            src={banner.imageSrc}
            alt={banner.imageAlt}
            width={banner.width}
            height={banner.height}
            loading="lazy"
            className="global-promo-image"
          />
        </picture>
      </a>
    </section>
  );
}
